import type { PublicCheckoutPrefill } from '@/types/public-checkout';

export interface CheckoutPrefillFields {
  firstName?: string;
  lastName?: string;
  email?: string;
  company?: string;
  phone?: string;
  teamName?: string;
  billingAddressLine1?: string;
  billingAddressLine2?: string;
  billingAddressCity?: string;
  billingAddressState?: string;
  billingAddressPostalCode?: string;
  billingAddressCountry?: string;
}

export function splitFullName(value?: string | null): { firstName: string; lastName: string } {
  const normalized = value?.trim() ?? '';
  if (!normalized) {
    return { firstName: '', lastName: '' };
  }
  const parts = normalized.split(/\s+/);
  return {
    firstName: parts[0] ?? '',
    lastName: parts.slice(1).join(' '),
  };
}

export function buildPrefillValues(prefill?: PublicCheckoutPrefill): CheckoutPrefillFields {
  if (!prefill) {
    return {};
  }

  const { firstName, lastName } = splitFullName(prefill.name);

  return {
    firstName,
    lastName,
    email: prefill.email ?? '',
    company: prefill.company ?? '',
    phone: prefill.phone ?? '',
    teamName: prefill.workspaceName ?? '',
    billingAddressLine1: prefill.billingAddressLine1 ?? '',
    billingAddressLine2: prefill.billingAddressLine2 ?? '',
    billingAddressCity: prefill.billingAddressCity ?? '',
    billingAddressState: prefill.billingAddressState ?? '',
    billingAddressPostalCode: prefill.billingAddressPostalCode ?? '',
    billingAddressCountry: prefill.billingAddressCountry ?? '',
  };
}
